const SubAbasTasks = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/maisopcoes/tasks/ficha/${id}/dadosgerais`,
  },
  //   {
  //     label: 'Produtos',
  //     rota: `/daf/produtosdaf/denominacoes/ficha/${id}/produtos`,
  //   },
];

export default SubAbasTasks;
